import '../../App.css';
import React, { useContext, useEffect, useState } from 'react';
import { Form, Row, Col, Tabs, Tab } from 'react-bootstrap';
import { ApiContext } from '../../context/ApiContext';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie'
import { StyleContext } from '../../context/StyleContext';
import { AuthContext } from '../../context/AuthContext';

function SelectEmpresa() {

    const { corPrimaria, btnSelecionar, logoBranca } = useContext(StyleContext)
    const { ListaEmpresas, Empresas, setKey } = useContext(ApiContext)
    const { setEmpresaKey } = useContext(AuthContext)
    const [selectedEmpresaKey, setSelectedEmpresaKey] = useState('')

    const navigate = useNavigate()

    const handleSelect = (e) => {
        const empresaKey = e.target.value;
        setSelectedEmpresaKey(empresaKey);
    }

    const navegar = () => {
        if (!selectedEmpresaKey) {
            alert('Selecione uma empresa');
            return;
        }
        
        const empresaSelecionada = Empresas.find(emp => emp.key === selectedEmpresaKey);
        
        if (empresaSelecionada) {
            setEmpresaKey(selectedEmpresaKey);
            setKey(selectedEmpresaKey);
            
            Cookies.set('Empresa', empresaSelecionada.fantasia);
            Cookies.set("Key", selectedEmpresaKey);
            
            navigate('/dashboard');
        }
    }

    useEffect(() => {
        ListaEmpresas()
    }, [])

    return (
        <div className="AppEmpresa" style={{ backgroundColor: corPrimaria }}>
            <div className='logoEmpresa'>
                <img src={`${logoBranca}`} alt="logo" />
            </div>
            <Form.Select aria-label="Default select example" onChange={handleSelect} style={{width: '30%', margin: '20px 0'}}>
                <option value="">Selecione</option>
                {Empresas &&
                    Empresas?.map((item) => {
                        return (
                            <option key={item.id} value={item.key}>{item.fantasia}</option>
                        )
                    })

                }
            </Form.Select>
            <button style={btnSelecionar} onClick={() => navegar()}>selecionar</button>
        </div>
    );
}

export default SelectEmpresa;